if (!customElements.get('image-slideshow-custom')) {
  customElements.define('image-slideshow-custom', class ImageSlideshowCustom extends HTMLElement {
    connectedCallback() {
      if (window.FoxTheme && window.FoxTheme.Carousel) {
        this.initSlider();
      } else {
        // If theme.js is not loaded yet, wait for DOMContentLoaded and then check
        document.addEventListener('DOMContentLoaded', () => {
          this.initSlider();
        });
      }
    }

    initSlider() {
      const container = this.querySelector('.swiper');
      const wrapper = this.querySelector('.swiper-wrapper');
      const slides = this.querySelectorAll('.swiper-slide');
      if (slides.length <= 1) return;

      const autoplayEnabled = this.dataset.autoplay === 'true';
      const speed = parseInt(this.dataset.speed) || 5000;

      if (window.FoxTheme && window.FoxTheme.Carousel) {
        const modules = [];
        if (autoplayEnabled && window.FoxTheme.Swiper && window.FoxTheme.Swiper.Autoplay) {
          modules.push(window.FoxTheme.Swiper.Autoplay);
        }

        const options = {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true,
            bulletClass: 'swiper-pagination-bullet',
            bulletActiveClass: 'swiper-pagination-bullet-active',
          },
          navigation: {
            nextEl: this.querySelector('.swiper-btn-next'),
            prevEl: this.querySelector('.swiper-btn-prev'),
          },
          threshold: 2,
        };

        if (autoplayEnabled) {
          options.autoplay = {
            delay: speed,
            disableOnInteraction: false,
          };
        }

        this.sliderInstance = new window.FoxTheme.Carousel(container, options, modules);
        this.sliderInstance.init();
      } else {
        // Fallback lightweight slider if Swiper is not loaded
        let currentIndex = 0;
        let interval = null;
        const pagination = this.querySelector('.swiper-pagination');

        // Clear existing pagination
        pagination.innerHTML = '';

        // Create bullets
        slides.forEach((_, i) => {
          const bullet = document.createElement('span');
          bullet.className = `swiper-pagination-bullet${i === 0 ? ' swiper-pagination-bullet-active' : ''}`;
          bullet.addEventListener('click', () => goToSlide(i));
          pagination.appendChild(bullet);
        });

        const bullets = pagination.querySelectorAll('.swiper-pagination-bullet');

        const goToSlide = (index) => {
          currentIndex = (index + slides.length) % slides.length;
          wrapper.style.transform = `translateX(-${currentIndex * 100}%)`;
          wrapper.style.transition = 'transform 0.5s ease-in-out';
          bullets.forEach((bullet, i) => {
            bullet.classList.toggle('swiper-pagination-bullet-active', i === currentIndex);
          });
        };

        // Navigation buttons
        const prevBtn = this.querySelector('.swiper-btn-prev');
        const nextBtn = this.querySelector('.swiper-btn-next');
        if (prevBtn) {
          prevBtn.addEventListener('click', () => {
            goToSlide(currentIndex - 1);
          });
        }
        if (nextBtn) {
          nextBtn.addEventListener('click', () => {
            goToSlide(currentIndex + 1);
          });
        }

        // Setup styles for fallback
        container.style.position = 'relative';
        container.style.overflow = 'hidden';
        wrapper.style.display = 'flex';
        wrapper.style.width = '100%';
        slides.forEach(slide => {
          slide.style.width = '100%';
          slide.style.flexShrink = '0';
        });

        if (autoplayEnabled) {
          interval = setInterval(() => {
            goToSlide(currentIndex + 1);
          }, speed);
          
          this.addEventListener('mouseenter', () => clearInterval(interval));
          this.addEventListener('mouseleave', () => {
            clearInterval(interval);
            interval = setInterval(() => {
              goToSlide(currentIndex + 1);
            }, speed);
          });
        }
      }
    }
  });
}
